/**
 * Created by Ivan on 10.08.2026
 */

const StickersCollectionWindow2 = Prefab.createWindow("stickers2_collection_window", "stickers2_collection_window_prefab_json", {
    bundles: (collection) => [SeasonCollectionsHelper2.getCollectionBundleName(collection.index, collection.season)]
});
